export default __webpack_public_path__ + "static/media/age_oxo.f3b706e7.png";